const getRequiredMessage = (key: string) => {
	return `Поле ${key} не заполнено`;
};

const getNumberLatinFormatMessage = (key: string) => {
	return `${key} может состоять только из цифр, букв латинского алфавита,минимум одной заглавной буквы и спецсимволов`;
};

const getFormatMessage = (key: string) => {
	return `${key} не соответствует формату`;
};

const getMaxMessage = (key: string, max: number) => {
	return `Поле ${key} должно состоять менее чем из ${max} символов`;
};

const getLengthMessage = (key: string, length: number) => {
	return `Поле ${key} должно состоять минимум из ${length} символов`;
};

const getRangeMessage = (key: string, min: number, max: number) => {
	return `Поле ${key} должно быть от ${min} до ${max} символов`;
};

const getInvalidMessage = (key: string) => {
	return `Введен неверный ${key}`;
};

const getInvalidConfirmPass = () => {
	return `Пароли не совпадают`;
};

export const validationErrors = {
	getRequiredMessage,
	getNumberLatinFormatMessage,
	getFormatMessage,
	getMaxMessage,
	getLengthMessage,
	getRangeMessage,
	getInvalidMessage,
	getInvalidConfirmPass,
};
